import { ChangeDetectionStrategy, Component } from '@angular/core'
import { IRegisterFormData } from '@adex/shared/models/auth/register-form-data'
import { registerFormDataToUserDto } from '@adex/store/utils/auth-data-converter'
import { Store } from '@ngrx/store'
import { createUser } from '@adex/store/actions/auth.actions'
import { IDynamicFormModel } from '@adex/shared/modules/dynamic-form/models/dynamic-form.model'
import { BaseLoaderContainer } from '@adex/shared/models/loaders/base-loader-container'
import { DynamicFormStateService } from '@adex/shared/modules/dynamic-form'
import { DynamicModelLoaderService } from '@adex/shared/services/dynamic-model-loader.service'
import { DynamicFormConditionStateService } from '@adex/shared/modules/dynamic-form/states/dynamic-form-condition-state.service'
import { Observable } from 'rxjs'
import { selectLoading } from '@adex/store/selectors'
import { urls } from '@adex/shared/network/urls'
import { map } from 'rxjs/operators'


@Component({
  selector: 'adex-register-container',
  templateUrl: './register-container.component.html',
  styleUrls: [ './register-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ { provide: DynamicFormStateService, useClass: DynamicFormConditionStateService } ]
})
export class RegisterContainerComponent extends BaseLoaderContainer<IDynamicFormModel> {

  constructor(private readonly store: Store, loader: DynamicModelLoaderService) {
    super(loader, 'register_individual-form')
  }

  public readonly loadingFormState$: Observable<boolean> = this.store.select(selectLoading(urls.user.create)).pipe(
    map(state => state.isLoading)
  )

  public onSubmitForm(data: IRegisterFormData): void {
    const userDto = registerFormDataToUserDto(data)
    this.store.dispatch(createUser({ userDto }))
  }

}
